<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/Newspent"
          v-if="auth.can('SETTINGS') && auth.can('SETTINGS')"
        >
          Nouvelle dépense
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field === 'type'" class="text-nowrap">
            <b>{{ props.row.type }}</b>
          </span>

          <span v-else-if="props.column.field === 'title'" class="text-nowrap">
            <b>{{ props.row.title }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'pay_mode'"
            class="text-nowrap"
          >
            <b>{{ props.row.pay_mode }}</b>
          </span>

          <span v-else-if="props.column.field === 'amount'" class="text-nowrap">
            <b>{{ props.row.amount }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            {{ getDate(props.row.created_at) }}
          </span>
          <span
            v-else-if="props.column.field === 'spent_date'"
            class="text-nowrap"
          >
            <template v-if="props.row.spent_date != null">
              {{ getDate(props.row.spent_date) }}<br />
            </template>
          </span>

          <span
            v-else-if="props.column.field === 'user_id'"
            class="text-nowrap"
          >
            {{ props.row.user?.name ?? "" }}
          </span>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('SETTINGS')">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'EditSpentPage',
                      params: {
                        id: props.row.id,
                      },
                    }"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>

                <li v-if="auth.can('SETTINGS')">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeSpent(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
                <!-- <li>
                  <a
                    v-if="
                      auth.can('RECEPTION') &&
                      props.row.note_stock_total_parcel != 0
                    "
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li> -->
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";

export default {
  name: "ListeSpents",

  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const columns = [
      {
        label: "Type",
        field: "type",
      },

      {
        label: "Titre",
        field: "title",
      },
      {
        label: "Description",
        field: "description",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Date de dépense",
        field: "spent_date",
      },
      {
        label: "Mode de paiment",
        field: "pay_mode",
      },
      {
        label: "Action par",
        field: "user_id",
      },

      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchTerm: "",
      searchType: "",
      searchMode: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      getRecords();
    });
    async function getRecords(page = 1) {
      isLoader.value = true;
      filters.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/spents?payment_mode=${filters.searchMode}&type=${filters.searchType}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   customer_filter = store_filter = { id: '', name: '' }
      //   date_filter = status_filter = type_date_filter = ''
      //   $refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeSpent(row) {
      const data = new FormData();

      const result = await Swal.fire({
        text: "Vous voulez supprimer cette dépense ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.delete(`/api/auth/spents/${row.id}`);

          if (res.data.success) {
            showToast("Dépense est bien supprimée", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else  {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

   

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/BCRPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,
      removeSpent,
      getPDF,
      noteRow,
    };
  },
};
</script>